// World + camera configuration for the Agent Kingdom.
// All percentages are relative to the map image they sit on.
// Overview art: kingdom-map.jpg (1672x941). World art: world-*.jpg (1448x1086).

export const WORLDS = {
  leads: {
    name: "Leads World",
    sub: "Sourcing · Outreach · Content · Pipeline",
    color: "#2E7DD1",
    emblem: "⚓",
  },
  clients: {
    name: "Clients World",
    sub: "Onboarding · Planning · Coaches · Retention",
    color: "#2F9E4F",
    emblem: "🌲",
  },
  internal: {
    name: "Internal World",
    sub: "Money · Contracts · Team · Work Management",
    color: "#B5342C",
    emblem: "🏰",
  },
};

// Overview camera focus targets: center (cx, cy) in % of image, zoom factor z.
export const REGIONS = {
  king: { cx: 49.5, cy: 21, z: 2.0 },
  leads: { cx: 16.5, cy: 66, z: 2.05 },
  clients: { cx: 49.5, cy: 67, z: 2.0 },
  internal: { cx: 82.5, cy: 63, z: 2.05 },
};

// Overview clickable hotspot rectangles, in % of image.
export const HOTSPOTS = {
  king: { left: 34, top: 2, width: 31, height: 36 },
  leads: { left: 2.5, top: 38, width: 28, height: 57 },
  clients: { left: 34.5, top: 40, width: 30, height: 57 },
  internal: { left: 68, top: 33, width: 29.5, height: 60 },
};

export const STATUS = {
  WORKING: "working",
  IDLE: "idle",
  APPROVE: "needs_approval",
  BLOCKED: "blocked",
  // never reported through the MCP — the house is on the map but nobody is home
  OFFLINE: "offline",
};

export const NEEDS_YOU = [STATUS.APPROVE, STATUS.BLOCKED];

export const STATUS_LABEL = {
  [STATUS.WORKING]: "Working",
  [STATUS.IDLE]: "Standing by",
  [STATUS.APPROVE]: "Waiting on you",
  [STATUS.BLOCKED]: "Blocked",
  [STATUS.OFFLINE]: "Not reporting yet",
};

export const slugify = (name) =>
  name.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
